import routes from '@/modules/core/mixins/routes';

export default {
  mixins: [routes],
  computed: {
    myAccountLinks() {
      return this.routes
        .reduce((acc, cur) => {
          let myAccountRoutes = [];
          if (cur.name === 'MyAccount' && cur?.children.length) {
            myAccountRoutes = cur.children.filter((item) => item.meta.showInMyAccountMenu);
          } else if (cur.name === 'Logout') {
            myAccountRoutes = [cur];
          }

          return [...acc, ...myAccountRoutes];
        }, []);
    },
  },
};
